import { OnboardingPage } from 'src/features/workspaces'

/**
 * Chrome for the workspace-create flow.
 *
 * None here: `OnboardingPage` wears `PublicSplitShell` itself — the same stage
 * as the sign-in screens, wordmark and legal links included. Wrapping it in a
 * second shell would print both twice, and the flow is deliberately a
 * continuation of signing up rather than a page of the app it has not entered.
 *
 * Always this stage, whether or not the user already owns workspaces: framing
 * the flow in the sidebar of the workspace being left behind puts the old
 * workspace next to a preview of the new one. Creating the second workspace
 * should read exactly like creating the first.
 *
 * `AuthGuard` wraps this route, so the session is already resolved here.
 */
export const WorkspaceCreateRoute = () => <OnboardingPage />
